import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15ba986c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin":"0 10px"} }, "至", -1))
const _hoisted_3 = { style: {"display":"flex"} }
const _hoisted_4 = { style: {"display":"flex"} }
const _hoisted_5 = { class: "operat-style-box" }
const _hoisted_6 = { class: "operat-content-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_SelectCategory = _resolveComponent("SelectCategory")!
  const _component_SelectLevel = _resolveComponent("SelectLevel")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_ui_button = _resolveComponent("ui-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_ui_table = _resolveComponent("ui-table")!
  const _component_ui_page = _resolveComponent("ui-page")!
  const _component_ui_container = _resolveComponent("ui-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ui_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_ui_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            class: "search-box",
            "label-width": "100px"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_el_form_item, { label: "添加时间" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.condition.startTime,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.condition.startTime) = $event)),
                        type: "datetime",
                        placeholder: "开始日期"
                      }, null, 8, ["modelValue"]),
                      _hoisted_2,
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.condition.endTime,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.condition.endTime) = $event)),
                        type: "datetime",
                        placeholder: "结束日期"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_form_item, { label: "分销员" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "text",
                      modelValue: _ctx.condition.name,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.condition.name) = $event)),
                      placeholder: "请输入分销员名称"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "分组" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectCategory, {
                      modelValue: _ctx.condition.category,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.condition.category) = $event)),
                      multiple: true
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "等级" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectLevel, {
                      modelValue: _ctx.condition.level,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.condition.level) = $event)),
                      multiple: true
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_el_form_item, {
                label: "",
                style: {"margin-bottom":"0"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_el_button, {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.find())),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("筛选")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_link, {
                      type: "primary",
                      style: {"margin":"0 0 0 10px"},
                      onClick: _ctx.resetFilter,
                      underline: false
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("重置筛选条件")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ui_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_tabs, {
            type: "card",
            class: "tabbar-box"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: "分销员列表",
                name: "0"
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_ui_button, {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$goto({ name: 'salesman-operat', })))
            }, {
              default: _withCtx(() => [
                _createTextVNode("添加分销员")
              ]),
              _: 1
            }),
            _createVNode(_component_ui_button, {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$goto({ name: 'salesman-level' })))
            }, {
              default: _withCtx(() => [
                _createTextVNode("分销方案")
              ]),
              _: 1
            }),
            _createVNode(_component_ui_button, {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$goto({ name: 'salesman-category' })))
            }, {
              default: _withCtx(() => [
                _createTextVNode("分组标签")
              ]),
              _: 1
            })
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_ui_table, {
            data: _ctx.source.list
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "昵称",
                prop: "name"
              }),
              _createVNode(_component_el_table_column, {
                label: "手机号码",
                prop: "phoneInfo.phone"
              }),
              _createVNode(_component_el_table_column, { label: "等级" }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.levelInfo ? row.levelInfo.name : '--'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, { label: "分组" }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.categoryInfo ? row.categoryInfo.name : '--'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "余额",
                prop: "amount"
              }),
              _createVNode(_component_el_table_column, {
                label: "累计销售额",
                prop: "totalSaleAmount"
              }),
              _createVNode(_component_el_table_column, {
                label: "累计佣金",
                prop: "totalAmount"
              }),
              _createVNode(_component_el_table_column, { label: "加入时间" }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(_ctx.$format(row.createTime)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "操作",
                width: "160"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_el_link, {
                      type: "primary",
                      onClick: ($event: any) => (_ctx.$goto({ name: 'salesman-view', query: { id: row.id } }))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("详情")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_link, {
                      type: "primary",
                      onClick: ($event: any) => (_ctx.$goto({ name: 'salesman-operat', query: { id: row.id } }))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_link, {
                      onClick: ($event: any) => (_ctx.deleteRow(row.id)),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _ctx.source.loading]
          ]),
          _createVNode(_component_ui_page, {
            modelValue: _ctx.page.page,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.page.page) = $event)),
            info: _ctx.pageInfo
          }, null, 8, ["modelValue", "info"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}